import { render, staticRenderFns } from "./SettingPanel.vue?vue&type=template&id=6e626f3a&scoped=true"
import script from "./SettingPanel.vue?vue&type=script&lang=js"
export * from "./SettingPanel.vue?vue&type=script&lang=js"
import style0 from "./SettingPanel.vue?vue&type=style&index=0&id=6e626f3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e626f3a",
  null
  
)

export default component.exports